module.exports = __webpack_public_path__ + "img/b-location.d0cb7756.svg";